
  import {Component, Vue} from 'vue-property-decorator';
  import ICognitoUserData from '@/types/cognitoUserData';
  import {
    Getter,
    Action,
  } from 'vuex-class';

  @Component
  export default class SignIn extends Vue {
    public $refs!: {
      form: any,
    };

    private loading: boolean = false;
    private user: any = {
      username: null,
      password: null,
    };

    @Getter('guest/auth/username') private username!: string;
    @Action('guest/auth/signIn') private storeSignIn!: (user: ICognitoUserData) => Promise<any>;
    @Getter('guest/auth/challenge') private challenge!: any;
    @Getter('common/rules/all') private rules!: any[];

    public mounted() {
      if (this.username) {
        this.user.username = this.username;
      }
    }

    private async signIn(e: Event) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.loading = true;

        // TODO: Check if true or false is returned. If it is true, login was successful.
        // TODO: If it is false, login was unsuccessful and there might be a challenge
        const success = await this.storeSignIn(this.user);
        this.loading = false;

        if (success) {
          this.$router.push({name: 'UserBase'});
        } else {
          switch (this.challenge) {
            case 'UserNotConfirmedException':
              this.$router.push({name: 'ConfirmSignUp'});
              break;
            case 'PasswordResetRequiredException':
              this.$router.push({name: 'CompleteNewPassword'});
              break;
            case 'RESET_REQUIRED':
              this.$router.push({name: 'ForgotPasswordSubmit'});
              break;
            case 'NEW_PASSWORD_REQUIRED':
              this.$router.push({name: 'NewPasswordRequired'});
              break;
          }
        }
        // .then((res: any) => {
        //   this.loading = false;
        //   if (res && res.challengeName === 'NEW_PASSWORD_REQUIRED') {
        //     this.$router.push({ name: 'CompleteNewPassword' });
        //   } else if (res && res.code === 'RESET_REQUIRED') {
        //     this.$router.push({ name: 'ForgotPasswordSubmit' });
        //   } else {
        //     this.$router.push({ name: 'UserBase' });
        //   }
        // });
      }
    }
  }
